import {
    ADD_BAR, BAR_BOOKINGS, BAR_ERROR, BOOK_BAR, CANCEL_BAR_BOOKING, DELETE_BAR_BOOKING, LOAD_BAR, MY_BAR_BOOKINGS
} from '../actions/types';

const initialState = {
    bar: null,
    bars: [],
    bookings: [],
    loading: true,
    error: {}
}

export default function foo(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case BAR_ERROR:
            return{
                ...state,
                error: payload,
                loading: false,
            };
        case LOAD_BAR:
            return {
                ...state,
                bars: payload,
                loading: false,
            };
        case ADD_BAR:
            return {
                ...state,
                bars: [payload, ...state.bars],
                loading: false
            };
        case BAR_BOOKINGS:
            return {
                ...state,
                bookings: payload,
                loading: false,
            };
        case MY_BAR_BOOKINGS:
            return {
                ...state,
                bookings: payload,
                loading: false,
            };
        case BOOK_BAR:
            return {
                ...state,
                bookings: [payload, ...state.bookings],
                loading: false
            };
        case DELETE_BAR_BOOKING:
            return {
                ...state,
                bookings: state.bookings.filter(booking => booking._id !== payload),
                loading: false
            };
        case CANCEL_BAR_BOOKING:
            return {
                ...state,
                bookings: state.bookings.map(booking => booking._id === payload._id ? { ...booking, status: payload.status } : booking),
                loading: false
            };
        default:
            return state;
    }
}